export class HelperObject {
  static camelToSnakeKey(chave: string): string {
    return chave.replace(/([A-Z])/g, '_$1').toLowerCase();
  }

  static camelToSnake<T extends Record<string, unknown>>(objeto: T): Record<string, unknown> {
    const resultado: Record<string, unknown> = {};
    for (const [chave, valor] of Object.entries(objeto)) {
      resultado[HelperObject.camelToSnakeKey(chave)] = valor;
    }
    return resultado;
  }

  static deepCamelToSnake<T extends Record<string, unknown>>(objeto: T): Record<string, unknown> {
    const resultado: Record<string, unknown> = {};
    for (const [chave, valor] of Object.entries(objeto)) {
      const snakeKey = HelperObject.camelToSnakeKey(chave);
      if (valor !== null && typeof valor === 'object' && !Array.isArray(valor)) {
        resultado[snakeKey] = HelperObject.deepCamelToSnake(valor as Record<string, unknown>);
      } else {
        resultado[snakeKey] = valor;
      }
    }
    return resultado;
  }
}
